import { Pipe, PipeTransform } from '@angular/core';

import { Observable, map } from 'rxjs';

@Pipe({
  name: 'finNegate',
  standalone: false,
})
export class NegatePipe implements PipeTransform {
  transform<T>(input: Observable<T> | T): Observable<boolean> | boolean {
    if (input instanceof Observable) {
      return input.pipe(map((a) => !a));
    }
    return !input;
  }
}
